import { useState } from 'react';
import type { CodFieldValue } from '@xshop/shared';
import type { CheckoutAnswers } from '../components/OnePageCheckout';

// Holds the shopper's answers above the order form, so re-pricing the order (which redraws the form) never loses what they typed.
export function useCheckoutAnswers(initialOfferId: string | null): CheckoutAnswers {
  const [values, setValues] = useState<Record<string, CodFieldValue>>(() => Object.create(null));
  const [acceptedOfferId, acceptOffer] = useState<string | null>(initialOfferId);
  // Prototype-less, as the form's own copy is: field keys come from the merchant, so `constructor` must read as absent.
  const setValue = (key: string, value: CodFieldValue) => setValues((current) => Object.assign(Object.create(null), current, { [key]: value }));
  return { values, setValue, acceptedOfferId, acceptOffer };
}
